<template>
  <div class="" style="padding-bottom: 50px">
    <div class="sub-title">设备预检</div>
    <el-form
      v-if="
        [
          dictMap['pre_inspection_of_receiving_goods'].id,
          dictMap['under_repair'].id,
        ].includes(orderData.status)
      "
      ref="form"
      :rules="rules"
      :model="info"
      label-width="80px"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="设备状态" prop="equipmentStatus">
            <el-select
              clearable
              v-model="info.equipmentStatus"
              placeholder="请选择"
            >
              <el-option
                v-for="item in equipmentStatusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="检测结果描述" prop="testResultDescription">
            <el-input
              type="textarea"
              v-model="info.testResultDescription"
              placeholder="请输入文字描述，限制4-200字符。"
              :rows="2"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item
          label="图片/视频：（请上传最多5张JPEG/PNG/GIF图片或MP4视频，总大小不超30MB）"
        >
          <div class="">
            <uploadFile
              ref="uploadFile1"
              @fileChange="fileChange1"
              :attachmentList="[...preInspectionAttachmentList]"
            ></uploadFile>
          </div>
        </el-form-item>
      </el-row>
    </el-form>
    <div v-else>
      <el-row :gutter="20">
        <el-col :span="16"
          ><div class="grid-content">
            <span class="label-left">设备状态</span
            ><span class="desc-text">{{
              getEquStatusText(info.equipmentStatus) || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16"
          ><div class="grid-content">
            <span class="label-left">检测结果描述</span
            ><span class="desc-text">{{
              info.testResultDescription || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20"
          ><div class="grid-content">
            <span class="label-left">图片/视频</span>
            <div
              v-if="
                preInspectionAttachmentList &&
                preInspectionAttachmentList.length > 0
              "
            >
              <imgPreview
                :attachmentList="[...preInspectionAttachmentList]"
              ></imgPreview>
              <!-- <uploadFile
                :showDel="false"
                @fileChange="fileChange"
                :attachmentList="[...preInspectionAttachmentList]"
              ></uploadFile> -->
              <!-- <img
                v-for="(item, index) in preInspectionAttachmentList"
                :key="index"
                :src="item"
                alt=""
              /> -->
            </div>
            <div v-else>-</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="sub-title">设备维修</div>
    <el-form
      v-if="
        [
          dictMap['pre_inspection_of_receiving_goods'].id,
          dictMap['under_repair'].id,
        ].includes(orderData.status)
      "
      ref="repairForm"
      :model="info"
      :rules="repairRules"
      label-width="80px"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="维修方式" prop="repairMethod">
            <el-select
              :disabled="!devRepairStatus"
              clearable
              v-model="info.repairMethod"
              placeholder="请选择"
            >
              <el-option
                v-for="item in repairMethodList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="维修内容描述" prop="repairContentDescription">
            <el-input
              :disabled="!devRepairStatus"
              type="textarea"
              v-model="info.repairContentDescription"
              placeholder="请输入文字描述，限制200字符。"
              :rows="2"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item
          label="图片/视频：（请上传最多5张JPEG/PNG/GIF图片或MP4视频，总大小不超30MB）"
        >
          <div class="">
            <uploadFile
              ref="uploadFile2"
              :isAble="devRepairStatus"
              @fileChange="fileChange"
              :attachmentList="[...repairAttachmentList]"
            ></uploadFile>
          </div>
        </el-form-item>
      </el-row>
    </el-form>
    <div v-else>
      <el-row :gutter="20">
        <el-col :span="16"
          ><div class="grid-content">
            <span class="label-left">维修方式</span
            ><span class="desc-text">{{
              getRepairMethodText(info.repairMethod) || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16"
          ><div class="grid-content">
            <span class="label-left">维修内容描述</span
            ><span class="desc-text">{{
              info.repairContentDescription || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20"
          ><div class="grid-content">
            <span class="label-left">图片/视频</span>
            <div v-if="repairAttachmentList && repairAttachmentList.length > 0">
              <imgPreview
                :attachmentList="[...repairAttachmentList]"
              ></imgPreview>
              <!-- <uploadFile
                :showDel="false"
                @fileChange="fileChange"
                :attachmentList="[...repairAttachmentList]"
              ></uploadFile>
               -->
              <!-- <img
                v-for="(item, index) in repairAttachmentList"
                :key="index"
                :src="item"
                alt=""
              /> -->
            </div>
            <div v-else>-</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import uploadFile from "./uploadFile.vue";
import { getDictMap } from "../../../utils/util";
import imgPreview from "./imgPreview.vue";
export default {
  components: {
    uploadFile,
    imgPreview,
  },
  props: {
    orderData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // editableStatus: [
      //   dictMap["pre_inspection_of_receiving_goods"].id,
      //   dictMap["under_repair"].id,
      // ],
      info: {
        equipmentStatus: "", //设备状态
        testResultDescription: "", //检测结果描述
        preInspectionAttachment: "", //设备预检 图片/视频
        repairMethod: "", //维修方式 字典ID
        repairContentDescription: "", //维修内容描述
        repairAttachment: "", //设备预检 图片/视频
      },
      equipmentStatusList: [],
      repairMethodList: [],
      preInspectionAttachmentList: [],
      repairAttachmentList: [],
      devRepairStatus: false,
      rules: {
        equipmentStatus: [
          { required: true, message: "请输入设备状态", trigger: "change" },
        ],
        testResultDescription: [
          { required: true, message: "请输入检测结果描述", trigger: "blur" },
        ],
      },
      dictMap: {},
      repairRules: {},
    };
  },
  watch: {
    orderData(newVal) {
      if (
        Object.keys(this.orderData) &&
        Object.keys(this.orderData)?.length !== 0
      ) {
        if (
          this.orderData?.preInspectionAttachmentList &&
          this.orderData?.preInspectionAttachmentList.length > 0
        ) {
          this.preInspectionAttachmentList = [
            ...this.orderData.preInspectionAttachmentList,
          ];
        }
        if (
          this.orderData?.repairAttachmentList &&
          this.orderData?.repairAttachmentList.length > 0
        ) {
          this.repairAttachmentList = this.orderData.repairAttachmentList;
        }
        // this.userInfo = { ...newVal };
        this.info = {
          ...this.info,
          ...Object.fromEntries(
            Object.keys(this.info).map((key) => [key, newVal[key]])
          ),
        };
      }
    },
    "info.equipmentStatus": {
      handler(newVal) {
        if (
          (this.info.equipmentStatus ===
            this.dictMap["damaged_and_in_need_of_repair"].id ||
            this.info.equipmentStatus ===
              this.dictMap["damaged_and_scrapped"].id) &&
          this.orderData.status ===
            this.dictMap["pre_inspection_of_receiving_goods"].id
        ) {
          this.devRepairStatus = true;
        } else {
          this.devRepairStatus = false;
        }
        if (this.orderData.status === this.dictMap["under_repair"].id) {
          this.handDevRepairStatus(newVal);
        }
      },
      deep: true,
    },
  },
  created() {
    this.dictMap = getDictMap();
  },
  mounted() {
    this.getDict();
    if (this.orderData.status === this.dictMap["under_repair"].id) {
      this.handDevRepairStatus(this.info.equipmentStatus);
    }
    // this.handDevRepairStatus(this.orderData.equipmentStatus);
  },
  methods: {
    getRepairMethodText(id) {
      const type = this.repairMethodList.find((item) => item.id === id);
      return type ? type.name : "";
    },
    getEquStatusText(id) {
      const type = this.equipmentStatusList.find((item) => item.id === id);
      return type ? type.name : "";
    },
    handDevRepairStatus(val) {
      if (val === this.dictMap["damaged_and_in_need_of_repair"]?.id) {
        //有损，需维修
        this.repairRules = {
          repairMethod: [
            {
              required: true,
              message: "请输入设备维修方式",
              trigger: "change",
            },
          ],
          repairContentDescription: [
            { required: true, message: "请输入维修内容描述", trigger: "blur" },
          ],
        };
        this.devRepairStatus = true;
      } else if (val === this.dictMap["damaged_and_scrapped"]?.id) {
        //有损，已报废
        this.devRepairStatus = true;
        if (Object.keys(this.repairRules).length !== 0) {
          this.$refs.repairForm.clearValidate("repairMethod");
          this.$refs.repairForm.clearValidate("repairContentDescription");
        }
        this.repairRules = {};
      } else {
        this.devRepairStatus = false;
        if (Object.keys(this.repairRules).length !== 0) {
          this.$refs.repairForm.clearValidate("repairMethod");
          this.$refs.repairForm.clearValidate("repairContentDescription");
        }
        this.repairRules = {};
      }
    },
    fileChange1(flie) {
      console.log("flie==", flie);
      this.info.preInspectionAttachment = flie.join(",");
      console.log(
        "this.info.preInspectionAttachment",
        this.info.preInspectionAttachment
      );
    },
    fileChange(flie) {
      this.info.repairAttachment = flie.join(",");
    },
    getDict() {
      this.equipmentStatusList = this.dictMap["equipment_status"]?.children;
      this.repairMethodList = this.dictMap["repair_method"]?.children;
    },
  },
};
</script>

<style lang="less" scoped>
.sub-title {
  margin: 20px 0;
  font-size: 16px;
  font-weight: 500;
  color: #1d2129;
}
::v-deep .el-textarea {
  .el-textarea__inner {
    //background: #f2f3f5;
    // border: none;
  }
}
::v-deep .el-input__count {
  line-height: 12px;
  //background: #f2f3f5 !important;
}
.grid-content {
  margin: 12px 0;
  font-weight: 500;
  font-size: 14px;
  color: #86909c;
  display: flex;
  align-items: center;
  input {
    height: 22px;
  }
  img {
    width: 80px;
    height: 80px;
    margin-right: 12px;
  }
}
.label-left {
  display: inline-block;
  width: 110px;
}
</style>
